import React from 'react';
import PropTypes from 'prop-types';
import { useSocket } from '../../context/SocketContext';

const PRIORIDAD_COLOR = { critica: '#C0392B', alta: '#e67e22', media: '#f1c40f', baja: '#27ae60' };
const ESTADO_LABEL = { pendiente: 'Pendiente', en_curso: 'En curso', cerrado: 'Cerrado' };

function TiempoRelativo({ ts }) {
  const diff = Math.floor((Date.now() - ts) / 1000);
  if (diff < 60) return <span>{diff}s</span>;
  if (diff < 3600) return <span>{Math.floor(diff / 60)}m</span>;
  return <span>{Math.floor(diff / 3600)}h</span>;
}
TiempoRelativo.propTypes = { ts: PropTypes.number.isRequired };

export default function NotificacionPanel({ onClose }) {
  const { notificaciones, marcarTodasLeidas } = useSocket();

  const handleOpen = () => {
    marcarTodasLeidas();
  };

  return (
    <div
      style={{
        position: 'fixed', top: 0, right: 0, height: '100vh', width: 360, zIndex: 500,
        background: '#1a1a2e', borderLeft: '1px solid rgba(255,255,255,.1)',
        boxShadow: '-4px 0 20px rgba(0,0,0,.4)',
        display: 'flex', flexDirection: 'column',
      }}
      onMouseEnter={handleOpen}
    >
      {/* Header */}
      <div style={{ padding: '18px 20px', borderBottom: '1px solid rgba(255,255,255,.08)', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <span style={{ color: '#fff', fontWeight: 700, fontSize: '1rem' }}>🔔 Alertas</span>
        <button onClick={onClose} style={{ background: 'none', border: 'none', color: 'rgba(255,255,255,.5)', cursor: 'pointer', fontSize: '1.1rem' }}>✕</button>
      </div>

      {/* Lista */}
      <div style={{ flex: 1, overflowY: 'auto', padding: '12px 0' }}>
        {notificaciones.length === 0 && (
          <div style={{ color: 'rgba(255,255,255,.35)', textAlign: 'center', marginTop: 40, fontSize: '.85rem' }}>
            Sin alertas recientes
          </div>
        )}
        {notificaciones.map((n, i) => (
          <div key={i} style={{
            padding: '12px 20px', borderBottom: '1px solid rgba(255,255,255,.05)',
            background: n._leida ? 'transparent' : 'rgba(192,57,43,.08)',
            display: 'flex', flexDirection: 'column', gap: 4,
          }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <span style={{ color: '#fff', fontWeight: 600, fontSize: '.85rem', textTransform: 'capitalize' }}>
                {n._tipo === 'nuevo' ? '🚨' : '🔄'} {n.tipo}
              </span>
              <span style={{ color: 'rgba(255,255,255,.35)', fontSize: '.72rem' }}>
                <TiempoRelativo ts={n._ts} />
              </span>
            </div>
            <div style={{ color: 'rgba(255,255,255,.6)', fontSize: '.78rem' }}>📍 {n.direccion}</div>
            <div style={{ display: 'flex', gap: 8, marginTop: 2 }}>
              <span style={{ background: PRIORIDAD_COLOR[n.prioridad], color: '#fff', borderRadius: 4, padding: '1px 7px', fontSize: '.7rem', fontWeight: 700 }}>
                {n.prioridad?.toUpperCase()}
              </span>
              <span style={{ background: 'rgba(255,255,255,.1)', color: 'rgba(255,255,255,.6)', borderRadius: 4, padding: '1px 7px', fontSize: '.7rem' }}>
                {ESTADO_LABEL[n.estado] || n.estado}
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

NotificacionPanel.propTypes = {
  onClose: PropTypes.func.isRequired,
};
